<template>
  <div :class="$style.homeBg">
    <video :class="$style.backgroundVideo"
           autoplay
           preload="auto"
           muted
           poster="@/assets/img/main-bg.jpg"
           loop
           playsinline>
      <source :src="backgroundVideo"
              type="video/mp4">
    </video>
    <DesktopHeader v-if="!$route.meta.hideHeader"/>
    <DesktopRegistrationHeader v-if="$route.meta.registrationHeader"/>
    <LoadingSpinner v-if="isLoading && !isGuest"/>
    <v-content v-else>
      <Cart :display="showCart"
            :current-page="$route.name"
            @closeCart="setCartDisplay(false)"
            @checkout="checkout"/>
      <router-view :key="$route.fullPath"/>
      <CommonModal :display="authModalSignIn"
                   :width="720"
                   title="Join / Sign In"
                   type="BigModal"
                   name="signIn"
                   @toggleModal="setModalSignInVisibility">
        <SignIn @phoneChecked="phoneCheckedSignIn"
                @close="setModalSignInVisibility(false)"/>
      </CommonModal>
      <CommonModal :display="authModalClaimAccount"
                   :width="720"
                   title="Claim Account"
                   type="BigModal"
                   @toggleModal="setModalClaimAccountVisibility">
        <ClaimAccount @phoneChecked="phoneCheckedClaimAccount"
                      @close="setModalClaimAccountVisibility(false)"/>
      </CommonModal>
      <CommonModal :display="authModalLogin"
                   :width="720"
                   title="Welcome Back"
                   type="BigModal"
                   @toggleModal="setModalLoginVisibility">
        <Login @close="setModalLoginVisibility(false)"
               @forgotPassword="setForgotPassword"
               @authorized="setModalLoginVisibility(false)"/>
      </CommonModal>
      <CommonModal :display="authForgotPassword"
                   :width="720"
                   title="Forgot Password"
                   type="BigModal"
                   name="forgotPassword"
                   @toggleModal="setForgotPasswordVisibility">
        <ForgotPassword
          @linkSent="setLinkSent"
          @close="setModal('forgotPassword', false)"/>
      </CommonModal>
      <CommonModal :display="authModal('resetPassword')"
                   :width="720"
                   title="Password Reset"
                   type="BigModal"
                   name="resetPassword"
                   @toggleModal="setResetPasswordVisibility(arguments[1])">
        <PasswordReset
          @close="setResetPasswordVisibility(false)"/>
      </CommonModal>
      <CommonModal :display="authModal('linkSent')"
                   :width="280"
                   :always-modal="true"
                   title="Password Reset"
                   type="SmallModal"
                   name="linkSent"
                   @toggleModal="setModal">
        <LinkSent @close="setModal('linkSent', false)"/>
      </CommonModal>
      <!-- Modal when quantity is 0 -->
      <CommonModal :display="modalInfo('cartItemRemove') !== null"
                   :always-modal="true"
                   width="480"
                   type="AppendModal"
                   title="Remove Item"
                   name="cartItemRemove"
                   @toggleModal="modalUpdate({ name: 'cartItemRemove' })">
        <ConfirmModalContent
          message="Are you sure you want to remove this item from your order?"
          confirm-text="YES, REMOVE"
          cancel-text="NO"
          @confirm="handleRemoveItem"
          @cancel="modalUpdate({ name: 'cartItemRemove' })"/>
      </CommonModal>
      <!-- Modal when you want to edit item -->
      <CommonModal :display="modalInfo('cartItemEdit') !== null"
                   :always-modal="true"
                   width="480"
                   type="AppendModal"
                   title="Abandon Boss Creation?"
                   name="cartItemEdit"
                   @toggleModal="modalUpdate({ name: 'cartItemEdit' })">
        <ConfirmModalContent
          message="Are you sure you want to abandon this creation?"
          confirm-text="YES, ABANDON"
          cancel-text="NO"
          @confirm="handleConfirmEditItem"
          @cancel="modalUpdate({ name: 'cartItemEdit' })"/>
      </CommonModal>
      <!-- Modal when you want to edit item -->
      <CommonModal :display="modalInfo('cartItemAdd')"
                   :always-modal="true"
                   width="480"
                   type="AppendModal"
                   title="Abandon Boss Creation?"
                   name="cartItemAdd"
                   @toggleModal="modalUpdate({ name: 'cartItemAdd' })">
        <ConfirmModalContent
          message="Are you sure you want to abandon this creation?"
          confirm-text="YES, ABANDON"
          cancel-text="NO"
          @confirm="addNewItem"
          @cancel="modalUpdate({ name: 'cartItemAdd' })"/>
      </CommonModal>
      <!-- Modal when you want to reset order -->
      <CommonModal :display="modalInfo('cartOrderCancel')"
                   :always-modal="true"
                   width="480"
                   type="AppendModal"
                   title="Cancel Order?"
                   name="cartOrderCancel"
                   @toggleModal="modalUpdate({ name: 'cartOrderCancel' })">
        <ConfirmModalContent
          message="Are you sure you want to cancel your entire order?"
          confirm-text="YES, CANCEL"
          cancel-text="NO"
          @confirm="cancelOrder"
          @cancel="modalUpdate({ name: 'cartOrderCancel' })"/>
      </CommonModal>
      <!-- Modal when you want to edit item -->
      <CommonModal :display="modalInfo('goToMenuOrMain')"
                   :always-modal="true"
                   width="480"
                   type="AppendModal"
                   title="Abandon Boss Creation?"
                   name="goToMenuOrMain"
                   @toggleModal="modalUpdate({ name: 'goToMenuOrMain' })">
        <ConfirmModalContent
          message="Are you sure you want to abandon this creation?"
          confirm-text="YES, ABANDON"
          cancel-text="NO"
          @confirm="goToMenuOrMain"
          @cancel="modalUpdate({ name: 'goToMenuOrMain' })"/>
      </CommonModal>
      <CommonModal :display="modalInfo('checkoutModal')"
                   :always-modal="true"
                   width="700"
                   type="BigModal"
                   name="checkoutModal"
                   title="Checkout"
                   @toggleModal="modalUpdate({ name: 'checkoutModal' })">
        <CheckoutModal @create-account="handleCreateAccount"
                       @guest-checkout="handleGuestCheckout"
                       @sign-in="handleSignIn"/>
      </CommonModal>
      <CommonModal :display="modalInfo('guestCheckoutModal')"
                   :always-modal="true"
                   width="700"
                   type="BigModal"
                   name="guestCheckoutModal"
                   title="Guest Checkout"
                   @toggleModal="modalUpdate({ name: 'guestCheckoutModal' })">
        <GuestCheckoutModal @continue="checkout"
                            @create-account="handleCreateAccount"
                            @sign-in="handleSignIn"/>
      </CommonModal>
      <!-- Configurator help modal -->
      <CommonModal :display="showHelpModal"
                   :width="helpModalWidth"
                   always-modal
                   type="SmallModal"
                   no-padding
                   @toggleModal="toggleHelpModal()">
        <HelpModal />
      </CommonModal>
      <!-- / Configurator help modal -->
    </v-content>
    <ApiErrors />
  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { Action, Getter, Mutation } from 'vuex-class';
import { AUTH_MODAL, AUTH_GUEST_TOKEN } from '@/apps/auth/store/types';
import MobileDetect from 'mobile-detect';
import {
  CART_DISPLAY,
  CART_ITEM_REMOVE,
  CART_RESET,
  ORDER_CREATE,
  ORDER_SET_RESTAURANT,
  ORDER_SET_TYPE,
  CART_PREPARE_ORDER,
  CART_CALC_ORDER,
  ORDER_PATCH,
} from '@/apps/cart/store/types';
import {
  MODAL_UPDATE,
  MODAL_CLOSE_ALL,
} from '@/apps/core/store/types';
import { KIOSK_BREAKPOINT } from '@/config/constants';
import DesktopHeader from '@/apps/desktop/components/DesktopHeader';
import DesktopRegistrationHeader from '@/apps/desktop/components/DesktopRegistrationHeader';
import DesktopCheckoutHeader from '@/apps/desktop/components/DesktopCheckoutHeader';
import Cart from '@/apps/cart/components/Cart';
import CommonModal from '@/apps/shared/components/CommonModal';
import SignIn from '@/apps/auth/components/SignIn';
import ClaimAccount from '@/apps/auth/components/ClaimAccount';
import Login from '@/apps/auth/components/Login';
import CancelOrderModal from '@/components/CancelOrderModal';
import ForgotPassword from '@/apps/auth/components/ForgotPassword';
import PasswordReset from '@/apps/auth/components/PasswordReset';
import LinkSent from '@/apps/auth/components/LinkSent';
import AccountCreated from '@/apps/auth/components/AccountCreated';
import ConfirmModalContent from '@/components/ConfirmModalContent';
import GuestCheckoutModal from '@/components/GuestCheckoutModal';
import CheckoutModal from '@/components/CheckoutModal';
import {
  CONFIGURATOR_PRODUCT,
  CONFIGURATOR_CLEAR,
  HIDE_HELP,
} from '@/apps/configurator/store/types';
import ApiErrors from '@/components/ApiErrors';
import { Watch } from 'vue-property-decorator';
import HelpModal from '@/components/HelpModal';
import helpers from '@/lib/helpers';
import LoadingMixin from '@/lib/mixins/loading-mixin';
import LoadingSpinner from '@/apps/configurator/components/LoadingSpinner';

const ROUTES_ALLOWED_ON_MOBILE = [
  'reset-password',
];

/**
 * Provide layout for desktop web application. This could be used to place
 * header and other default components for web application view.
 */
@Component({
  components: {
    LoadingSpinner,
    HelpModal,
    ApiErrors,
    ConfirmModalContent,
    GuestCheckoutModal,
    CheckoutModal,
    LinkSent,
    ForgotPassword,
    CancelOrderModal,
    DesktopHeader,
    DesktopRegistrationHeader,
    DesktopCheckoutHeader,
    Cart,
    CommonModal,
    SignIn,
    ClaimAccount,
    Login,
    PasswordReset,
    AccountCreated,
  },
  mixins: [
    LoadingMixin,
  ],
})
export default class DesktopLayout extends Vue {
  @Getter modalInfo;
  // Auth modal windows
  @Getter authModal;
  // Sign in modal
  @Getter authModalSignIn;
  // Claim account modal
  @Getter authModalClaimAccount;
  // Login modal
  @Getter authModalLogin;
  @Getter authForgotPassword;
  // User data
  @Getter authUser;
  @Getter orderItemId;
  @Getter cart;
  @Getter order;
  @Getter orderType;
  @Getter restaurantId;
  @Getter orderItemPrice;
  @Getter orderItemCompleted;
  @Getter orderItem;
  @Getter('configuratorHelpShow') showHelpModal;
  @Getter isGuest;
  @Getter cartIsEmpty;
  @Getter isKioskPlatform;
  @Getter getPreparedItems;

  @Mutation(AUTH_MODAL) setAuthModal;
  @Action(MODAL_UPDATE) modalUpdate;
  @Action(MODAL_CLOSE_ALL) modalCloseAll;
  @Action(CART_ITEM_REMOVE) cartRemoveItem;
  @Action(CART_DISPLAY) cartDisplay;
  @Action(CART_RESET) cartReset;
  @Action(CONFIGURATOR_PRODUCT) setCurrentProduct;
  @Action(ORDER_SET_RESTAURANT) setRestaurantId;
  @Action(ORDER_SET_TYPE) setOrderType;
  @Action(ORDER_CREATE) orderCreate;
  @Action(CART_PREPARE_ORDER) prepareOrder;
  @Action(CONFIGURATOR_CLEAR) clearConfigurator;
  @Action(HIDE_HELP) hideHelp;
  @Action(CART_CALC_ORDER) cartCalcOrder;
  @Action(ORDER_PATCH) updateOrder;
  @Action(AUTH_GUEST_TOKEN) getNewGuestToken;

  /**
   * Client width.
   */
  clientWidth = document.documentElement.clientWidth;

  /**
   * Help modal width computed.
   * @return {Number} modal width in px.
   */
  get helpModalWidth() {
    if (this.clientWidth === KIOSK_BREAKPOINT) {
      return 900;
    }

    return 317;
  }

  /**
   * Get background image url.
   */
  get backgroundVideo() {
    return helpers.getImagePath('burgerBuild.mp4');
  }

  /**
   * Open resetPassword modal if
   * router's params have token and uid from reset password email
   */
  @Watch('$route', { immediate: true, deep: true })
  onUrlChange() {
    if (this.$route.params.token || this.$route.params.uid) {
      this.setResetPasswordVisibility(true);
    }
  }

  /**
   * Mounted vue hook.
   */
  mounted() {
    window.addEventListener('resize', () => {
      this.clientWidth = document.documentElement.clientWidth;
    });
  }

  /**
   * Detect mobile platform.
   *
   * @return {boolean}
   **/
  get isMobileDetect() {
    const md = new MobileDetect(window.navigator.userAgent);

    return !!md.mobile();
  }

  /**
   * Check if current route is allowed on mobile.
   */
  get isCurrentRouteAllowedOnMobile() {
    return ROUTES_ALLOWED_ON_MOBILE.some(route => route === this.$route.name);
  }

  /**
   * Set display value for Forgot password modal
   * @param {boolean} value - defines if modal should be opened on closed
   */
  setResetPasswordVisibility(value) {
    this.setAuthModal({
      name: 'resetPassword',
      value,
    });
    if (!value) {
      this.$router.push({ name: 'home' });
    }
  }


  /**
   * Set display value for Sign In modal
   * @param {boolean} value - defines if modal should be opened on closed
   */
  setModalSignInVisibility(value) {
    this.setAuthModal({
      name: 'signIn',
      value,
    });
  }

  /**
   * Set display value for selected modal
   * @param {boolean} value - defines if modal should be opened on closed
   */
  setModalClaimAccountVisibility(value) {
    this.setAuthModal({
      name: 'claimAccount',
      value,
    });
  }

  setModal(name, value) {
    this.setAuthModal({
      name,
      value,
    });
  }

  /**
   * Set display value for Login modal
   * @param {boolean} value - defines if modal should be opened on closed
   */
  setModalLoginVisibility(value) {
    this.setAuthModal({
      name: 'login',
      value,
    });
  }

  /**
   * Set display value for Forgot password modal
   * @param {boolean} value - defines if modal should be opened on closed
   */
  setForgotPasswordVisibility(value) {
    this.setAuthModal({
      name: 'forgotPassword',
      value,
    });
  }

  /**
   * Set LinkSent modal active and close forgotPassword modal after email with
   * reset link was sent
   */
  setLinkSent() {
    this.setForgotPasswordVisibility(false);
    this.setModal('linkSent', true);
  }

  @Getter showCart;
  @Mutation(CART_DISPLAY) cartDisplayAction;

  setCartDisplay(value) {
    this.cartDisplayAction(value);
  }

  /**
   * Handler of the event sent from ClaimAccount Modal
   *
   * @param {Boolean} profileExists - The status of existence of the account
   */
  phoneCheckedClaimAccount({ profileExists }) {
    this.setModalClaimAccountVisibility(false);
    if (profileExists) {
      this.setModalLoginVisibility(true);
    } else {
      this.$router.push({ name: 'create-account', params: { goAfterCreation: '/menu' } });
    }
  }

  /**
   * Handler of the event sent from SignIn Modal
   *
   * @param {Boolean} profileExists - The status of existence of the account
   */
  phoneCheckedSignIn({ profileExists }) {
    this.setModalSignInVisibility(false);
    if (profileExists) {
      this.setModalLoginVisibility(true);
    } else {
      this.$router.push({ name: 'create-account', params: { goAfterCreation: '/menu' } });
    }
  }

  /**
   * Handler of the event sent from Login for set Forgot Password modal
   */
  setForgotPassword() {
    this.setModalLoginVisibility(false);
    this.setForgotPasswordVisibility(true);
  }

  /**
   * Handler for "confirm" in Remove Item modal
   *
   * Call the action to remove the item from the Cart, and close the modal
   */
  handleRemoveItem() {
    const itemId = this.modalInfo('cartItemRemove');

    this.cartRemoveItem(itemId);
    if (itemId === this.orderItemId) {
      this.$router.push({ name: 'menu' });
    }

    this.cartDisplay(false);
    this.modalUpdate({ name: 'cartItemRemove' });

    if (this.cartIsEmpty) {
      this.cartReset();
      if (this.isGuest) {
        this.getNewGuestToken();
      }
    } else if (this.order && this.order.promotionCodeApplied && this.isKioskPlatform) {
      const promoCode = this.order.promotionCodeApplied;

      this.cartCalcOrder({ promoCode });
    } else {
      this.cartCalcOrder();
    }
  }

  /**
   * Handler for "confirm" in Edit Item modal
   *
   * Call the action to remove the item from the Cart, and close the modal
   */
  handleConfirmEditItem() {
    this.startEditItem(this.modalInfo('cartItemEdit'));
  }

  /**
   * Start editing item
   */
  startEditItem(itemId) {
    if (!this.orderItemCompleted) {
      this.cartRemoveItem(this.orderItemId);
    }
    this.clearConfigurator();

    const item = this.cart[itemId];

    this.setCurrentProduct({
      productKey:  item.productKey,
      orderItemId: itemId,
      orderItem:   item.data,
    });

    this.modalUpdate({ name: 'cartItemEdit' });
    this.cartDisplay(false);
    this.$router.push({ name: 'configurator', params: { id: item.productKey } });
  }

  /**
   * Cancel order and empty cart
   */
  cancelOrder() {
    if (this.isGuest) {
      this.getNewGuestToken();
    }

    this.cartReset();
    this.modalUpdate({ name: 'cartOrderCancel' });
    this.addNewItem();
  }

  /**
   * Redirect to menu, for adding new item to card
   */
  addNewItem() {
    if (!this.orderItemCompleted) {
      this.cartRemoveItem(this.orderItemId);
    }
    this.clearConfigurator();
    this.$router.push({ name: 'menu' });
    this.modalUpdate({ name: 'cartItemAdd' });
    this.cartDisplay(false);
  }

  /**
   * Handle click on logo
   *
   * If the user has chosen the order type and restaurant, send it to the menu,
   * otherwise send it to the main page.
   */
  goToMenuOrMain() {
    this.modalUpdate({ name: 'goToMenuOrMain' });
    if (this.orderType !== null && this.restaurantId !== null) {
      this.$router.push({ name: 'menu' });

      return;
    }

    this.setOrderType(null);
    this.setRestaurantId(null);

    this.$router.push({ name: 'main' });
  }

  /**
   * Event handler for "createAccount"
   *
   * Show the modal to create an account.
   */
  handleCreateAccount() {
    this.modalCloseAll();
    this.setAuthModal({
      name:  'signIn',
      value: true,
    });
  }

  /**
   * Event handler for "signIn"
   *
   * Show the modal to claim an account.
   */
  handleSignIn() {
    this.modalCloseAll();
    this.setAuthModal({
      name:  'claimAccount',
      value: true,
    });
  }

  /**
   * Event handler for "guestCheckout"
   *
   * Show the "guestCheckoutModal".
   */
  handleGuestCheckout() {
    this.modalCloseAll();
    this.modalUpdate({
      name: 'guestCheckoutModal',
      data: true,
    });
  }

  /**
   * Trigger on hide help modal.
   */
  toggleHelpModal() {
    this.hideHelp();
  }

  /**
   * Provide cart data preparation for order creation on backend.
   * @param payload
   */
  async checkout(payload) {
    if (!this.orderType) {
      this.$router.push({ name: 'main' });
    } else if (!this.restaurantId) {
      this.$router.push({ name: 'restaurant' });
    } else {
      try {
        this.loadingStart();

        if (payload.promoCode) {
          await this.updateOrder({
            promoCode: payload.promoCode,
            userData:  payload.userData,
            items:     this.getPreparedItems,
          });
          this.$router.push({ name: 'payment-confirm' });
        } else if (this.order) {
          await this.updateOrder({ items: this.getPreparedItems });
          this.$router.push({ name: 'payment-confirm' });
        } else {
          await this.prepareOrder();
          this.$router.push({ name: 'payment-confirm' });
        }
        this.$router.push({ name: 'checkout' });
        this.cartDisplay(true);
      } catch (e) {
        this.$router.push({ name: 'menu' });
        this.cartDisplay(true);
        throw e;
      } finally {
        this.loadingStop();
      }
    }
    this.modalCloseAll();
  }
}
</script>

<style lang='scss' module>
@import "~normalize.css";
@import "../style/global";

body {
  font-family: 'Gotham', Helvetica, sans-serif;
  font-size: 15px;
  color: $black;
}

.backgroundVideo {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  object-fit: cover;
}

.homeBg {
  display: flex;
  flex-direction: column;
  min-height: var(--layout-height);
}

@media screen and (max-width: 965px) {
  .homeBg {
    background-color: $light-choice-bg
  }
}

.appsButtons {
  display: flex;
  margin-top: 30px;

  a {
    display: inline-block;
    flex: 194px;

    img {
      width: 100%;
      height: auto;
    }
  }

   a + a {
    margin-left: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/DesktopLayout.vue